import { ref, get as dbGet } from 'firebase/database';
import { dbRealtime } from '../firebase';

// In-memory cache — never written to disk, cleared on page refresh
let memoryCache = null;

/**
 * Fetch raw mappings from Firebase (full download).
 */
async function fetchFromFirebase() {
    const snapshot = await dbGet(ref(dbRealtime, 'gl_mappings'));
    return snapshot.exists() ? snapshot.val() : {};
}

/**
 * Get raw mappings { key: value } — uses in-memory cache if available.
 */
export async function getMappingsRaw() {
    if (memoryCache) return memoryCache;
    const data = await fetchFromFirebase();
    memoryCache = data;
    return data;
}

/**
 * Get mappings as sorted array [{ id, description, glAccount }].
 */
export async function getMappingsArray() {
    const data = await getMappingsRaw();
    return Object.keys(data).map(key => {
        if (typeof data[key] === 'string') {
            return { id: key, description: key, glAccount: data[key] };
        } else if (data[key].description && data[key].glAccount) {
            return { id: key, description: data[key].description, glAccount: data[key].glAccount };
        } else {
            return { id: key, description: key, glAccount: 'Unknown' };
        }
    }).sort((a, b) => a.description.localeCompare(b.description));
}

/**
 * Invalidate in-memory cache. Call after any write to gl_mappings.
 */
export async function invalidateCache() {
    memoryCache = null;
}
